import { AxiosResponse } from "axios";
import http from "./httpService";

const baseUrl = "callQueue";

type UnixEpochTime = string;

interface queueStatisticsRequestArgs {
  workspaceId: string;
  assistantId: string;
  queuedAt: UnixEpochTime;
}

interface queueStatisticsResponse {
  message: string;
  data: {
    queuedAfter: UnixEpochTime;
    statistics: {
      pending: number;
      failed: number;
      completed: number;
    };
    totalCalls: number;
    callConcurrency: {
      concurrencyLimit: number;
      concurrentCalls: number;
    };
  };
}

function getQueueStatistics({
  workspaceId,
  queuedAt,
  assistantId,
}: queueStatisticsRequestArgs): Promise<
  AxiosResponse<queueStatisticsResponse>
> {
  const params = {
    ...(queuedAt ? { queuedAt } : {}),
  };

  return http.get(
    `${baseUrl}/whitelabelGetQueueStatistics/${workspaceId}/${assistantId}`,
    {
      params,
    }
  );
}

function getCurrentQueueStats({ workspaceId, assistantId }) {
  return http.get(
    `${baseUrl}/whitelabelGetCurrentQueueStatus/${workspaceId}/${assistantId}`
  );
}

function deletePendingCalls({ workspaceId, assistantId }) {
  return http.delete(
    `${baseUrl}/whitelabelCancelPendingCalls/${workspaceId}/${assistantId}`
  );
}

function putPausePendingCalls({ workspaceId, assistantId }) {
  return http.put(`${baseUrl}/whitelabelPausePendingCalls/${workspaceId}/${assistantId}`);
}

function putQueuePausedCalls({ workspaceId, assistantId }) {
  return http.put(`${baseUrl}/whitelabelQueuePausedCalls/${workspaceId}/${assistantId}`);
}

function deletePausedCalls({ workspaceId, assistantId }) {
  return http.put(`${baseUrl}/whitelabelCancelPausedCalls/${workspaceId}/${assistantId}`);
}

export {
  getQueueStatistics,
  getCurrentQueueStats,
  deletePendingCalls,
  putPausePendingCalls,
  putQueuePausedCalls,
  deletePausedCalls
};
